import { useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";

const SuccessPage = () => {

  const user = useSelector((state) => state.AuthSlice.user);

  const navigate = useNavigate()

  const handleGoOnHome = () => {
    navigate('/');
    setTimeout(() => {
      window.location.reload();
    }, 0);
  };


  return (
    <>
      <div className="col-md-12 sample-pages-box">
        <div>
          <div className="subscripiton-plans-box subscription-height-box-main">
            <div className="container h-100">
              <div className="row h-100">
                <div className="col-md-12 mb-4 h-100">
                  <div className="subscription-card">
                    <div className={`about-text-box thank-you-text-content`}>
                      <div className="thank-you-tick-icon">
                        <i className="fa-solid fa-check"></i>
                      </div>

                      <h2 className="mt-0">
                        Payment successful!
                      </h2>
                      <p
                        className="common-text"
                        style={{ textTransform: "capitalize" }}
                      >
                        Thank you for your subscription! Your payment has been
                        successfully processed, and we’re excited to have you onboard.
                      </p>

                      <a onClick={handleGoOnHome} className="btn btn-primary">
                        Go Back to Home
                      </a>
                    </div>


                    {/* {user?.role?.name == "user" ? (
                      <Link to={"/user/subscriptions"}>Go Back to Home</Link>
                    ) : user?.role?.name == "professional" ? (
                      <Link to={"/professional/subscriptions"}>
                        Go Back to Home
                      </Link>
                    ) : user?.role?.name == "corporate" ? (
                      <Link to={"/corporate/subscriptions"}>
                        Go Back to Home
                      </Link>
                    ) : (
                      "")} */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SuccessPage;
